<template>
    <div class="uploads-side-menu">
        <input type="file" @change="onFileChange" name="file" id="file" class="inputfile">
        <label for="file" class="brandColor">Upload Image</label>
      
        <div class="is-thumbnail-area">
            <img  v-for="image in images" v-bind:key="image" :src="image" height="100px" 
            draggable="true" v-on:click="addImageToScene(image)" class="imageThumbnail">
        </div>
    </div>
</template>

<script>
import { bezieApp } from '../../lib/bezieLib/main';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';

export default {
    name: 'UploadsSideMenu',
    data: function(){
        return {
            images: [],
            KEY_IMAGES : "images",
            DELIMITER : "$"
        }
    },
    methods: {
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.createImage(files[0]);
        },

        createImage(file) {
            var reader = new FileReader();

            reader.onload = (e) => {
                this.addImage(e.target.result);
            };

            reader.readAsDataURL(file);
        },

        addImage(img){
            this.images.push(img);
            if(localStorage){
                var storedImgs = localStorage.getItem(this.KEY_IMAGES);
                if(storedImgs){
                    storedImgs = storedImgs + this.DELIMITER + img;
                }else{
                    storedImgs = img;
                }
                localStorage.setItem(this.KEY_IMAGES, storedImgs);
            }
        },

        addImageToScene: function (image) {
            UIEvents.addImageToCanvas(image)
        }
    },
    mounted: function(){
        if(localStorage){
            var storedImgs = localStorage.getItem(this.KEY_IMAGES);
            if(storedImgs){
                this.images = storedImgs.split(this.DELIMITER);
            }
        }
    }
}
</script>

<style scoped>

.imageThumbnail{
  margin:5px;
}

/** Input */

.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.inputfile + label {
    margin:4px;
    padding:6px 24px;
    border-radius: 4px;
    font-family: inherit;
    font-size: 12px;
    line-height: 1.5;
    color: white;
    background-color: #6190e8;
    display: inline-block;
    cursor: pointer; /* "hand" cursor */
    width: 90%;
}

.inputfile:focus + label,
.inputfile + label:hover {
    background-color: #fc4a1a;
}

.inputfile:focus + label {
	outline: 1px dotted #000;
	outline: -webkit-focus-ring-color auto 5px;
}
.inputfile + label * {
	pointer-events: none;
}
</style>